import React, { useState } from 'react';
import { useLocation } from "react-router-dom";
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'

import ManageAssets from '../../dump/menuComponents/ManageAssets'
import FleetOverview from "../../dump/menuComponents/FleetOverview";
import Migration from '../../dump/menuComponents/Migration'
import FleetConfigurationContainer from '../../smart/fleetConfiguration/FleetConfigurationContainer'
import GreyHeader from '../../GreyHeader'
import CustomButton from '../../CustomButton';
import DeviceHealth from '../../../pages/vehicles/DeviceHealth'

import { isCustomUserPermissions } from '../../helpers/helperUsers'
import { isInternalUserWithPartner } from '../../helpers/constants'

const ManageVehicles = (props) => {
	const routerLocation = useLocation();
	const location = routerLocation.state ? routerLocation : props.location;
	const { t } = useTranslation('translation', { keyPrefix: 'manageVehiclesPage.manageVehicles' });
	const { user, hasUnacknowledgedAlerts } = props
	const userRole = user.roles[0]
	const userPermissions = user.permissions

	const [tabKey, setTabKey] = useState(_.get(location, 'state.tabKey') || 1);
	const [selectedProfileName, setSelectedProfileName] = useState(_.get(location, 'state.profile_name') || '');
	const [device_id, setDevice_id] = useState(_.get(location, 'state.device_id') || null);
	const passedCompany = _.get(location, 'state.company') || null;

	const selectProfile = (e) => {
		setTabKey(2)
		setSelectedProfileName(e.target.name)
		setDevice_id('all')
	}

	const clearSelectedProfile = () => {
		setSelectedProfileName(null)
	}

	const canViewProfiles = ['system_admin', 'customer_service', 'partner', 'fleet_manager', 'sales_demo', 'storage_manager', 'custom_user', 'custom_partner'].includes(user.roles[0]);
	const bubbleShow = tabKey !== 4 && hasUnacknowledgedAlerts
	const headerOptions = {
		title: t('headerOptionsTitle')
	}
	const userMigrationAccess = ['system_admin', 'customer_service', 'partner', 'installer', 'partner_view', 'sales_demo'].includes(userRole) || (['custom_partner'].includes(userRole) && isCustomUserPermissions(userRole, user.permissions, 'vehicle_edit'));

	if (canViewProfiles) {
		headerOptions.renderSubtitle = (
			<nav className="page-subtitle block">
				{isCustomUserPermissions(userRole, userPermissions, 'settings_profile_disabledBtn') &&
					<CustomButton
						variant='subtitle'
						active={tabKey === 1}
						onClick={() => setTabKey(1)}
					>
						{t('btnAssets')}
					</CustomButton>}
				{isCustomUserPermissions(userRole, userPermissions, 'settings_profile_view') &&
					<CustomButton
						variant='subtitle'
						active={tabKey === 2}
						onClick={() => {
							setTabKey(2)
							setDevice_id(null)
						}}
					>
						{t('btnSettings')}
					</CustomButton>
				}
				{isCustomUserPermissions(userRole, userPermissions, 'settings_profile_disabledBtn') &&
					<CustomButton
						variant='subtitle'
						active={tabKey === 3}
						onClick={() => setTabKey(3)}
					>
						{t('btnFleetOverview')}
					</CustomButton>}
				{(isInternalUserWithPartner(userRole) || userRole === 'fleet_manager') &&
					<CustomButton
						variant='subtitle'
						active={tabKey === 4}
						onClick={() => {
							setTabKey(4);
							setDevice_id(null);
						}}
					>
						{t('btnDeviceHealth')}
						{bubbleShow && <label className="bubble-icon" />}
					</CustomButton>
				}
				{userMigrationAccess &&
					<CustomButton
						variant='subtitle'
						active={tabKey === 5}
						onClick={() => setTabKey(5)}
					>
						{t('btnMigration')}
					</CustomButton>}
			</nav>
		)
	}

	return (
		<>
			<GreyHeader {...headerOptions} />

			{tabKey === 1 &&
				<ManageAssets
					selectProfile={selectProfile}
					company={props.company}
				/>
			}
			{tabKey === 2 &&
				<FleetConfigurationContainer
					goToManageAssets={() => setTabKey(1)}
					selectedProfileName={selectedProfileName}
					clearSelectedProfile={clearSelectedProfile}
					device_id={device_id}
					passedCompany={passedCompany}
				/>
			}
			{tabKey === 3 &&
				<FleetOverview
					goToDeviceHealth={() => { setTabKey(4); }}
					goToManageAssets={() => { setTabKey(1); }}
				/>
			}
			{tabKey === 4 &&
				<DeviceHealth />
			}
			{tabKey === 5 &&
				<Migration />
			}
		</>
	);
}

ManageVehicles.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired,
	company: PropTypes.objectOf(PropTypes.any).isRequired,
	hasUnacknowledgedAlerts: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ user, company, assets }) => ({
	user: user.user,
	company: company.company,
	hasUnacknowledgedAlerts: assets.hasUnacknowledgedAlerts,
})

const mapDispatchToProps = dispatch => ({
	toggleLoader: (show) => {
		dispatch({ type: 'TOGGLE_LOADER', payload: show });
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageVehicles);
